import React from 'react';

import { MdDelete as DeleteIcon } from 'react-icons/md';
import IconButton from 'material-ui/IconButton';

const RemoveIcon = ({ onClick }) => (
  <IconButton
    style={{
      padding: 0,
      verticalAlign: 'text-bottom',
      width: 'none',
      height: 'none',
      float: 'right',
      marginRight: '25px',
    }}
    onClick={onClick}
  >
    <DeleteIcon size={24} style={{ padding: 0 }} />
  </IconButton>
);

export default RemoveIcon;
